module.exports = __webpack_public_path__ + "media/images/lightbox/prev@2x-31d963bda32c43c049d3026737156f1d.png";